<ul #nav="ngbNav" class="nav nav-pills" ngbNav orientation="vertical">
  <li ngbNavItem="">
    <a class="nav-pills-header" ngbNavLink>
      <fa-icon icon="search"></fa-icon> &nbsp;
      {{ "Browse" | translate }}
    </a>
  </li>

  <!-- Active Listings -->
  <li [ngbNavItem]="MarketplaceNavPage.ACTIVE_LISTINGS" class="subnav">
    <a
      *ngIf="getLink$(MarketplaceNavPage.ACTIVE_LISTINGS) | async as link"
      [queryParams]="link.queryParams"
      [routerLink]="link.path"
      [routerLinkActiveOptions]="routerLinkActiveOptions"
      ngbNavLink
      routerLinkActive="active"
    >
      <fa-icon icon="grip"></fa-icon> &nbsp;
      {{ "Active listings" | translate }}
    </a>
  </li>

  <!-- Pending moderation -->
  <li
    *ngIf="currentUser$ | async | isMarketplaceModerator"
    [ngbNavItem]="MarketplaceNavPage.PENDING_MODERATION"
    class="subnav"
  >
    <a
      *ngIf="getLink$(MarketplaceNavPage.PENDING_MODERATION) | async as link"
      [queryParams]="link.queryParams"
      [routerLink]="link.path"
      [routerLinkActiveOptions]="routerLinkActiveOptions"
      ngbNavLink
      routerLinkActive="active"
    >
      <fa-icon icon="gavel"></fa-icon> &nbsp;
      {{ "Pending moderation" | translate }}
    </a>
  </li>

  <!-- Sold Listings -->
  <li [ngbNavItem]="MarketplaceNavPage.SOLD_LISTINGS" class="subnav">
    <a
      *ngIf="getLink$(MarketplaceNavPage.SOLD_LISTINGS) | async as link"
      [queryParams]="link.queryParams"
      [routerLink]="link.path"
      [routerLinkActiveOptions]="routerLinkActiveOptions"
      ngbNavLink
      routerLinkActive="active"
    >
      <fa-icon icon="handshake"></fa-icon> &nbsp;
      {{ "Sold archive" | translate }}
    </a>
  </li>

  <ng-container *ngIf="currentUser$ | async">
    <li ngbNavItem="">
      <a class="nav-pills-header" ngbNavLink>
        <fa-icon icon="user"></fa-icon> &nbsp;
        {{ "My listings" | translate }}
      </a>
    </li>

    <!-- User Listings -->
    <li [ngbNavItem]="MarketplaceNavPage.USER_LISTINGS" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_LISTINGS) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="store"></fa-icon> &nbsp;
        {{ "Active listings" | translate }}
      </a>
    </li>

    <li [ngbNavItem]="MarketplaceNavPage.USER_SOLD_LISTINGS" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_SOLD_LISTINGS) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="sack-dollar"></fa-icon> &nbsp;
        {{ "Sold" | translate }}
      </a>
    </li>

    <li [ngbNavItem]="MarketplaceNavPage.USER_EXPIRED_LISTINGS" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_EXPIRED_LISTINGS) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="calendar-xmark"></fa-icon> &nbsp;
        {{ "Expired" | translate }}
      </a>
    </li>

    <li ngbNavItem="">
      <a class="nav-pills-header" ngbNavLink>
        <fa-icon icon="circle-check"></fa-icon> &nbsp;
        {{ "My interactions" | translate }}
      </a>
    </li>

    <!-- User Offers -->
    <li [ngbNavItem]="MarketplaceNavPage.USER_OFFERS" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_OFFERS) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="comment-dollar"></fa-icon> &nbsp;
        {{ "Offers" | translate }}
      </a>
    </li>

    <!-- User Purchases -->
    <li [ngbNavItem]="MarketplaceNavPage.USER_PURCHASES" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_PURCHASES) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="receipt"></fa-icon> &nbsp;
        {{ "Purchases" | translate }}
      </a>
    </li>

    <!-- User Followed -->
    <li [ngbNavItem]="MarketplaceNavPage.USER_FOLLOWED" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_FOLLOWED) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="bell"></fa-icon> &nbsp;
        {{ "Followed" | translate }}
      </a>
    </li>

    <!-- User feedback -->
    <li [ngbNavItem]="MarketplaceNavPage.USER_FEEDBACK" class="subnav">
      <a
        *ngIf="getLink$(MarketplaceNavPage.USER_FEEDBACK) | async as link"
        [queryParams]="link.queryParams"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="routerLinkActiveOptions"
        ngbNavLink
        routerLinkActive="active"
      >
        <fa-icon icon="star"></fa-icon> &nbsp;
        {{ "Feedback" | translate }}
      </a>
    </li>
  </ng-container>
</ul>
